module.exports = __webpack_public_path__ + "img/event.31dbd902.png";